import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn, PaginatedAPIFn } from "@/api/utils"

import { NotificationResponse, NotificationsOverview } from "./types"

export const NotificationQueryKey = createQueryKeys("notifications", {
  list: () => ({ queryKey: ["list"] }),
  overview: () => ({ queryKey: ["overview"] }),
})

type NotificationResourceType = {
  list: PaginatedAPIFn<NotificationResponse>
  overview: APIFn<NotificationsOverview>
  markAsRead: APIFn<void>
  markAsOpened: APIFn<void, { id: string | number }>
}

export const NotificationResource: NotificationResourceType = {
  list: (config) => axios.get("/doppler/v1/inapp-notifications/", config),

  overview: () => axios.get("/doppler/v1/inapp-notifications/overview/"),

  markAsRead: () => axios.put("/doppler/inapp-notifications/"),

  markAsOpened: ({ urlParams }) =>
    axios.put(`/doppler/v1/inapp-notifications/${urlParams.id}/`),
}
